import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import ThemeContextWrapper from "./components/Utils/Theme/ThemeWrapper";
import { Provider } from "react-redux";
import store from "./Store";

ReactDOM.render(
  <Provider store={store}>
    <ThemeContextWrapper>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeContextWrapper>
  </Provider>,
  document.getElementById("root")
);
reportWebVitals();
